import React from 'react';
import PropTypes from 'prop-types';

import FpToaster from 'forepaas/toaster';
import FpTranslate from 'forepaas/translate';
import authService from '../../../services/auth-service';
import FpPasswordStrength from '../FpPasswordStrength.jsx';
import '../styles/FpPasswordForgot.less';

class FpPasswordConfirm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      form: {
        email: props.email || '',
        code: '',
        newPassword: '',
        confirmPassword: ''
      },
      policies: false,
      isLoading: false
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleInputChange(event) {
    if (event.target && event.target.value !== undefined) {
      const target = event.target;
      const value = target.value;
      const name = target.name;
      const form = { ...this.state.form };
      form[name] = value;
      this.setState({ form });
    } else if (typeof event === 'string') {
      // Handle password from FpPasswordStrength
      const form = { ...this.state.form };
      form.newPassword = event;
      this.setState({ form });
    }
  }

  isCodeValid(code) {
    return /^\d{6}$/.test(code);
  }

  canSubmit() {
    const { email, code, newPassword, confirmPassword } = this.state.form;
    const { policies, isLoading } = this.state;

    return (
      email.length > 0 &&
      this.isCodeValid(code) &&
      newPassword.length > 0 &&
      newPassword === confirmPassword &&
      policies &&
      !isLoading
    );
  }

  getRepeatClass() {
    let repeatClass = 'form-input';
    const { newPassword, confirmPassword } = this.state.form;

    if (confirmPassword !== '' && newPassword !== '' &&
      newPassword !== confirmPassword) {
      repeatClass += ' error';
    } else {
      repeatClass += ' success';
    }

    return repeatClass;
  }

  setPolicies = (check) => {
    if (check !== this.state.policies) {
      this.setState({ policies: check });
    }
  }

  handleSubmit(event) {
    event.preventDefault();

    if (this.canSubmit()) {
      this.setState({ isLoading: true });

      const { email, code, newPassword } = this.state.form;

      authService.confirmResetPassword(email, code, newPassword)
        .then(message => {
          this.setState({
            form: {
              email: '',
              code: '',
              newPassword: '',
              confirmPassword: ''
            },
            isLoading: false
          });

          FpToaster.success('AuthenticationPasswordChangeSuccess');
          if (this.props.onSuccess) {
            this.props.onSuccess();
          }
        })
        .catch(err => {
          this.setState({ isLoading: false });
          FpToaster.error(err.message || FpTranslate('confirmation_failed'));
        });
    }
  }

  render() {
    const repeatClass = this.getRepeatClass();
    const { code } = this.state.form;
    const isCodeInvalid = code.length > 0 && !this.isCodeValid(code);

    return (
      <>
        <h1 className="login-title" style={{ padding: 'unset' }}>ログイン</h1>

        <form className="login-form" onSubmit={this.handleSubmit}>
          <div className='form-group'>
            <label className="form-label">メールアドレス</label>
            <input
              className="form-input"
              type="email"
              placeholder=""
              value={this.state.form.email}
              name="email"
              disabled
              style={{ color: '#FFFFFF' }}
            />
          </div>

          <div className='form-group'>
            <label className="form-label">メールに記載された認証コード</label>
            <input
              className={`form-input ${isCodeInvalid ? 'error' : ''}`}
              onChange={this.handleInputChange}
              type="text"
              name='code'
              value={this.state.form.code}
              placeholder="コード"
              style={{ color: '#FFFFFF' }}
            />
            {isCodeInvalid && <p className='error-info'>認証コードは6桁の数字で入力してください</p>}
          </div>

          <div className='form-group'>
            <FpPasswordStrength onChange={this.handleInputChange} minScore={2} setPolicies={this.setPolicies} policies={this.state.policies} />
          </div>

          <div className='form-group'>
            <label className="form-label">新しいパスワードを再度入力</label>
            <input
              onChange={this.handleInputChange}
              type='password'
              name='confirmPassword'
              placeholder="新しいパスワード"
              className={repeatClass}
              style={{ color: '#FFFFFF' }}
            />
            {repeatClass.includes('error') && <p className='error-info'>パスワードが一致しません</p>}
          </div>

          <button
            className="login-button"
            type="submit"
            disabled={!this.canSubmit()}
          >
            送信
          </button>

          <div className="forgot-password-container" style={{ marginTop: 'unset' }}>
            <span
              role="button"
              tabIndex={0}
              onClick={() => {
                if (this.props.close) this.props.close();
              }}
              onKeyPress={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  if (this.props.close) this.props.close();
                }
              }}
              className="forgot-password-link"
              style={{ display: 'inline' }}
            >
              キャンセル
            </span>
          </div>
        </form>
      </>
    );
  }
}

FpPasswordConfirm.propTypes = {
  close: PropTypes.func,
  color: PropTypes.string,
  email: PropTypes.string,
  onSuccess: PropTypes.func
};

export default FpPasswordConfirm; 